<template>
  <section class="gd-recent-transactions">
    <header class="gd-recent-transactions__header">
      <div>
        <h2>Recent Transactions</h2>
        <p>Latest GrooveSell activity from the past 30 days.</p>
      </div>
      <button type="button" @click="$emit('view-all')">View all</button>
    </header>
    <p v-if="loading" class="gd-recent-transactions__state">Loading recent transactions...</p>
    <p v-else-if="error" class="gd-recent-transactions__state">Recent transactions could not be loaded. Please refresh to try again.</p>
    <div v-else-if="rows.length" class="gd-recent-transactions__list">
      <article
        v-for="transaction in rows"
        :key="transaction.id"
        class="gd-recent-transactions__item"
        :style="{ backgroundColor: transaction.color, '--transaction-border': transaction.border }"
      >
        <div class="gd-recent-transactions__details">
          <div class="gd-recent-transactions__identity">
            <strong>{{ transaction.customer }}</strong>
            <span class="gd-recent-transactions__status">{{ transaction.status }}</span>
          </div>
          <span class="gd-recent-transactions__product">{{ transaction.product }}</span>
          <span v-if="transaction.flagged" class="gd-recent-transactions__flag">Suspected Fraud</span>
        </div>
        <div class="gd-recent-transactions__amount">
          <span v-if="transaction.amountLabel" class="gd-recent-transactions__amount-label">{{ transaction.amountLabel }}</span>
          <strong>{{ transaction.price }}</strong>
          <span>{{ transaction.date }}</span>
          <span>{{ transaction.time }}</span>
        </div>
      </article>
    </div>
    <p v-else class="gd-recent-transactions__state">No GrooveSell transactions in the past 30 days.</p>
  </section>
</template>

<script>
import { presentRecentTransaction } from './recentTransactions';

export default {
  name: 'RecentTransactions',
  props: {
    transactions: { type: Array, default: () => [] },
    loading: Boolean,
    error: Boolean,
  },
  computed: {
    rows() { return this.transactions.slice(0, 10).map(presentRecentTransaction); },
  },
};
</script>

<style scoped>
.gd-recent-transactions { min-width: 0; min-height: 360px; }
.gd-recent-transactions__header { display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; padding: 18px 20px; border-bottom: 1px solid #dcdcea; }
.gd-recent-transactions__header h2 { color: #191d3a; font-size: 20px; font-weight: 800; line-height: 1.2; margin: 0; }
.gd-recent-transactions__header p { color: #5b6680; font-size: 14px; line-height: 1.4; margin: 6px 0 0; }
.gd-recent-transactions__header button { flex-shrink: 0; min-height: 40px; padding: 8px 12px; border: 1px solid #dcdcea; border-radius: 6px; background: #fff; color: #11142d; font-size: 13px; font-weight: 700; cursor: pointer; }
.gd-recent-transactions__header button:hover { background: #eef3fb; border-color: #b8bfd3; }
.gd-recent-transactions__list { padding: 8px 12px 12px; }
.gd-recent-transactions__item { display: grid; grid-template-columns: minmax(0, 1fr) minmax(130px, auto); align-items: center; gap: 16px; min-height: 76px; padding: 12px; border-bottom: 1px solid #e5e9f0; border-left: 3px solid var(--transaction-border); }
.gd-recent-transactions__item:last-child { border-bottom: 0; }
.gd-recent-transactions__details { min-width: 0; }
.gd-recent-transactions__identity { display: flex; align-items: center; flex-wrap: wrap; gap: 6px 8px; }
.gd-recent-transactions__item strong { color: #191d3a; font-size: 14px; font-weight: 800; line-height: 1.4; overflow-wrap: anywhere; }
.gd-recent-transactions__status { padding: 2px 6px; border: 1px solid var(--transaction-border); border-radius: 4px; color: #323954; font-size: 11px; font-weight: 700; line-height: 1.4; }
.gd-recent-transactions__product, .gd-recent-transactions__amount > span { color: #5b6680; font-size: 13px; line-height: 1.4; overflow-wrap: anywhere; }
.gd-recent-transactions__product { display: block; margin-top: 4px; }
.gd-recent-transactions__flag { display: block; margin-top: 4px; color: #74510c; font-size: 12px; font-weight: 600; }
.gd-recent-transactions__amount { display: flex; flex-direction: column; align-items: flex-end; text-align: right; min-width: 0; gap: 2px; }
.gd-recent-transactions__amount > .gd-recent-transactions__amount-label { font-size: 11px; }
.gd-recent-transactions__state { color: #5b6680; font-size: 14px; padding: 22px 20px; margin: 0; }
@media (max-width: 480px) {
  .gd-recent-transactions__header { padding: 16px 12px; gap: 8px; }
  .gd-recent-transactions__header h2 { font-size: 18px; }
  .gd-recent-transactions__list { padding: 4px 0; }
  .gd-recent-transactions__item { gap: 10px; padding: 12px 8px; grid-template-columns: minmax(0, 1fr) minmax(112px, auto); }
  .gd-recent-transactions__amount > span { font-size: 12px; }
}
</style>
